import {Modal} from 'bootstrap';
import AOS from 'aos';
import axios from 'axios';
import * as FilePond from "filepond";
import CookieNotification from "bb-cookie-notification";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import Flickity from 'flickity';
import ModuloBox from './plugins/modulobox.js';
import './plugins/gridzy.min.js';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import {
    CountUp
} from 'countup.js';

// BenedenBoven cookiescript
new CookieNotification({
    content:         'We use <a href="/privacy-statement">cookies</a>',
    agreeButtonText: 'Agree'
});

// Init Animate On Scroll
AOS.init();

const removeOrAddDelays = () => {
    if(window.innerWidth < 1200) {
        document.querySelectorAll('[data-aos-delay]').forEach((el) => {
            el.removeAttribute('data-aos-delay');
        })
    }
}
removeOrAddDelays();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Enable BS Tooltips everywhere
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map((tooltipTriggerEl) => {
    return new Tooltip(tooltipTriggerEl)
});

// Enable BS Popovers everywhere
const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
popoverTriggerList.map((popoverTriggerEl) => {
    return new Popover(popoverTriggerEl)
});

if(document.querySelector('[data-video]')) {
    document.querySelectorAll('[data-video]').forEach((el) => {
        el.addEventListener('click', (event) => {
            document.getElementById('video-in-modal').src = event.currentTarget.dataset.video;
        });
    });

    document.querySelector('#videoModal').addEventListener('hidden.bs.modal', function(event) {
        document.getElementById('video-in-modal').src = '';
    });
}

if(document.querySelector('[data-redirect]')) {
    document.querySelectorAll('[data-redirect]').forEach((el) => {
        if(Cookies.get('disable-redirect-warning') !== 'true') {
            el.addEventListener('click', (event) => {
                event.preventDefault();
                Swal.fire({
                    title:              'You are now leaving ' + el.dataset.redirectFrom,
                    text:               "You will be redirected to our company: " + el.dataset.redirectTo,
                    icon:               'info',
                    input:              'checkbox',
                    inputValue:         0,
                    inputPlaceholder:   'Don\'t warn me again',
                    showCancelButton:   true,
                    confirmButtonColor: '#E72370',
                    cancelButtonColor:  '#243060',
                    confirmButtonText:  'Yes, take me there'
                }).then((result) => {
                    if(result.value === 1) {
                        Cookies.set('disable-redirect-warning', true, {
                            expires: 14
                        });
                    }

                    if(result.isConfirmed) {
                        window.location.href = el.href;
                    }
                })
            });
        }
    });
}

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Parallax
if(document.querySelector('#parallax')) {
    document.addEventListener("mousemove", parallax);
    const elem = document.querySelector("#parallax");

    function parallax(e) {
        let _w                        = window.innerWidth / 2;
        let _h                        = window.innerHeight / 2;
        let _mouseX                   = e.clientX;
        let _mouseY                   = e.clientY;
        let _depth                    = `${50 - (_mouseX - _w) * 0.01}% ${50 - (_mouseY - _h) * 0.01}%`;
        let x                         = `${_depth}`;
        elem.style.backgroundPosition = x;
    }
}

// Flickity
if(document.querySelector('.projects-slider')) {
    const flkty = new Flickity('.projects-slider', {
        cellAlign:      'left',
        contain:        true,
        wrapAround:     true,
        groupCells:     true,
        arrowShape:     '',
        setGallerySize: false
    });

    const slides                       = document.querySelectorAll('.projects-slider .carousel-cell');
    const handleFlickityViewportChange = () => {
        slides.forEach(slide => slide.style.height = '');

        let heights = Array.from(slides).map((slide) => slide.scrollHeight),
            max     = Math.max(... heights);

        slides.forEach((slide) => slide.style.height = max + 'px');
        document.querySelector('.projects-slider .flickity-viewport').style.height = (max + 50) + 'px';
    }
    window.addEventListener('resize', handleFlickityViewportChange);
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange);
}

if(document.querySelector('.customers-slider')) {
    const flkty = new Flickity('.customers-slider', {
        cellAlign:       'left',
        contain:         true,
        wrapAround:      true,
        groupCells:      true,
        arrowShape:      '',
        setGallerySize:  false,
        prevNextButtons: false,
        pageDots:        true,
        autoPlay:        2500
    });

    const slides                       = document.querySelectorAll('.customers-slider .carousel-cell');
    const handleFlickityViewportChange = () => {
        slides.forEach(slide => slide.style.height = '');

        let heights = Array.from(slides).map((slide) => slide.scrollHeight),
            max     = Math.max(... heights);

        slides.forEach((slide) => slide.style.height = max + 'px');
        document.querySelector('.customers-slider .flickity-viewport').style.height = (max + 50) + 'px';
    }
    window.addEventListener('resize', handleFlickityViewportChange);
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange);
}

// Modulobox
const modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div, .page-body :not(a) > img, .gallery img, [data-rel="gallery"]',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'close'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    caption:            true,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"></div>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]') || form.querySelector('#' + error);
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }

        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = 'Verstuur bericht';
    });
}

window.submitForm = submitForm;

if(document.getElementById('application-form')) {
    FilePond.registerPlugin(FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginFileEncode);
    const filepond = FilePond.create(document.querySelector('.files'), {
        allowMultiple:                         true,
        instantUpload:                         false,
        required:                              true,
        acceptedFileTypes:                     ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        fileValidateTypeLabelExpectedTypesMap: {
            'image/png':                                                               '.png',
            'image/jpeg':                                                              '.jpg',
            'image/jpg':                                                               '.jpg',
            'application/pdf':                                                         '.pdf',
            'application/msword':                                                      '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx'
        },
        labelFileTypeNotAllowed:               'Onjuist bestandstype!',
        fileValidateTypeLabelExpectedTypes:    'Alleen {allButLastType} en {lastType} zijn togestaan',
        labelIdle:                             'Sleep je cv/motivatie hiernaartoe of <span class="filepond--label-action"> blader </span>'
    });

    let currentlySending        = false;
    const submitApplicationForm = (gRecaptchaResponse) => {
        const applicationForm = document.getElementById('application-form');
        if(currentlySending === false) {

            currentlySending       = true;
            const submitButton     = applicationForm.querySelector('[type="submit"]');
            submitButton.innerHTML = '<i class="fad fa-circle-notch fa-spin"></i>';
            submitButton.disabled  = true;
            submitButton.classList.add('disabled');

            const formData = new FormData(applicationForm);
            formData.append('g-recaptcha-response', gRecaptchaResponse)
            const validationAlert = document.getElementById('application-form-validation');

            document.querySelectorAll('.invalid-feedback').forEach((element) => {
                if(!element.classList.contains('d-none')) {
                    element.classList.add('d-none');
                }
            });

            document.querySelectorAll('.is-invalid').forEach((element) => {
                element.classList.remove('is-invalid');
            });

            validationAlert.classList.add('hidden');
            validationAlert.classList.remove('alert-danger');
            axios.post(applicationForm.action, formData).then((response) => {
                if(response.data.success) {
                    validationAlert.innerHTML = response.data.message;
                    validationAlert.classList.add('alert-success');
                    validationAlert.classList.remove('hidden');

                    applicationForm.innerHTML = '';
                } else {
                    currentlySending       = false
                    submitButton.innerHTML = 'Verstuur';
                    submitButton.disabled  = false;
                    submitButton.classList.remove('disabled');
                }
            }).catch((exception) => {
                if(exception.response.data.errors) {
                    for(let error in exception.response.data.errors) {
                        const el = applicationForm.querySelector('[name="' + error + '"]') || applicationForm.querySelector('#' + error);
                        if(el !== null) {
                            el.classList.add('is-invalid');
                            if(el.parentNode.querySelector('.d-none') !== null) {
                                el.parentNode.querySelector('.d-none').classList.remove('d-none');
                            }
                        }
                    }
                }

                submitButton.classList.remove('disabled');
                submitButton.disabled  = false;
                submitButton.innerHTML = 'Verstuur bericht';
                currentlySending       = false;
            });
        }
    };

    window.submitApplicationForm = submitApplicationForm;
}

if(document.querySelector('[data-count-up]')) {
    window.addEventListener('scroll', (event) => {
        document.querySelectorAll('.facts-and-figures-item-container').forEach((el) => {
            const countUp = el.querySelector('[data-count-up]');
            if(el.classList.contains('aos-animate') && countUp && !countUp.classList.contains('started')) {
                countUp.classList.add('started');

                const isYear = countUp.dataset.isYear === 'true';
                new CountUp(countUp, countUp.dataset.countUp, {
                    duration:  3,
                    separator: (!isYear) ? '.' : '',
                    decimal:   ','
                }).start();
            }
        });
    });

    setTimeout(() => {
        window.dispatchEvent(
            new Event('scroll')
        );
    }, 100);
}